import { createFileRoute, redirect } from '@tanstack/react-router';
import { AtivarDoisFatores } from '@/features/auth/componentes/AtivarDoisFatores';
import { lerSessao } from '@/features/auth/guardas';

export const Route = createFileRoute('/ativar-2fa')({
  beforeLoad: async ({ context, location }) => {
    const me = await lerSessao(context);
    if (me === null) throw redirect({ to: '/entrar', search: { volta: location.href } });
    if (me.usuario.doisFatoresAtivo) throw redirect({ to: '/minha-conta', search: { aba: '2fa' } });
    return { obrigatorio: me.pendencias.includes('ATIVAR_2FA') };
  },
  component: PaginaAtivar2fa,
});

function PaginaAtivar2fa() {
  const { obrigatorio } = Route.useRouteContext();
  return <AtivarDoisFatores obrigatorio={obrigatorio} />;
}
